import { PDFDocument } from "pdf-lib";
import { jsPDF } from "jspdf";
import * as pdfjsLib from "pdfjs-dist";

/**
 * Compress the final PDF before uploading.
 * @param {Uint8Array} pdfBuffer - The generated PDF buffer.
 * @returns {Promise<File>} - Compressed PDF file.
 */
const compressPDF = async (pdfBuffer, originalFileName) => {
  const pdfDoc = await PDFDocument.load(pdfBuffer);
  pdfDoc.setCreator("Optimized PDF Generator");

  const compressedPdfBytes = await pdfDoc.save({
    useObjectStreams: true,
  });

  return new File([compressedPdfBytes], `${originalFileName}.pdf`, {
    type: "application/pdf",
  });
};

/**
 * Convert any file to a high-quality & compressed PDF.
 * @param {File} file - The file to convert.
 * @returns {Promise<File>} - Converted & compressed PDF file.
 */
export const convertToPDF = async (file) => {
  let pdfBuffer;

  if (file.type.startsWith("image/")) {
    // ✅ Images are uploaded as-is (No Conversion, No Compression)
    return file;
  } else if (file.name.endsWith(".pdf")) {
    pdfBuffer = await file.arrayBuffer();
  } else if (file.name.endsWith(".doc") || file.name.endsWith(".docx")) {
    // ✅ Upload `.doc` and `.docx` files as-is (No Conversion)
    return file;
  } else if (file.name.endsWith(".ppt") || file.name.endsWith(".pptx")) {
    // ✅ Upload PowerPoint files as-is (No Conversion)
    return file;
  } else {
    throw new Error("Unsupported file type.");
  }

  return await compressPDF(pdfBuffer, file.name.replace(/\.[^.]+$/, ""));
};
